<template>
	<transition :name="transitionName">
		<div class="back-to-ceiling" @click="backToTop" v-show="visible" :style="customStyle">
			<!-- <i class="el-icon-arrow-up"></i> -->
			<svg width="16" height="16" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg" class="icon icon--backToTopArrow" aria-hidden="true" style="height: 16px; width: 16px;">
				<title>回到顶部</title>
				<g>
				<path d="M12.036 15.59c0 .55-.453.995-.997.995H5.032c-.55 0-.997-.445-.997-.996V8.584H1.03c-1.1 0-1.36-.633-.578-1.416L7.33.29c.39-.39 1.026-.385 1.412 0l6.878 6.88c.782.78.523 1.415-.58 1.415h-3.004v7.004z" fill-rule="evenodd"></path>
				</g>
			</svg>
			<p>返回</p>
		</div>
	</transition>
</template>

<script>

export default {
	name: 'BackToTop',
	props: {
		visibilityHeight: {
			type: Number,
			default: 400
		},
		backPosition: {
			type: Number,
			default: 0
		},
		customStyle: {
			type: Object,
			default: function() {
				return {
					right: '15px',
					bottom: '170px',
					width: '50px',
					height: '50px',
					background: '#fff',
					border: '1px solid #F0F2F5',
					zIndex: 1000
				}
			}
		},
		transitionName: {
			type: String,
			default: 'fade'
		}
	},
	data() {
		return {
			visible: false,
			interval: null
		}
	},
	beforeDestroy() {
		this.$root.$el.removeEventListener('scroll', this.handleScroll)
		if (this.interval) {
			clearInterval(this.interval)
		}
	},
	mounted() {
		this.$root.$el.addEventListener('scroll', this.handleScroll)
	},
	methods: {
		handleScroll() {
			this.visible = this.$root.$el.scrollTop > this.visibilityHeight
		},
		backToTop() {
			this.$parent.allowscroll = false
			const start = this.$root.$el.scrollTop
			let i = 0
			this.interval = setInterval(() => {
				const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500))
				if (next <= this.backPosition) {
					this.$root.$el.scrollTo(0, this.backPosition)
					clearInterval(this.interval)
					this.$parent.allowscroll = true
				} else {
					this.$root.$el.scrollTo(0, next)
				}
				i++
			// 间隔越小速度越快
			}, 10.24)
		},
		easeInOutQuad(t, b, c, d) {
			if ((t /= d / 2) < 1) return c / 2 * t * t + b
			return -c / 2 * (--t * (t - 2) - 1) + b
		}
	}
}
</script>

<style lang="scss" scoped>
.back-to-ceiling {
	position: fixed;
	z-index: 1;
	display: inline-block;
	display: flex;
	flex-direction: column;
	justify-content: center;
	color: #666;
	text-align: center;
	cursor: pointer;
	p {
		line-height: 1.2;
		font-size: 12px;
	}
	&:hover {
		opacity: 0.85;
	}
	.icon--backToTopArrow {
		fill: #bfc1c8;
		background: none;
		margin: 0 auto 4px;
	}
}

.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
	opacity: 0
}
</style>
